export default "__VITE_ASSET__TEAqOyXb__"